module.exports = __webpack_public_path__ + "images/users/opt_in_modal/buttons-bg_a1bf2ace7f32aea392d3bef4ef2af4ff.png";